/**
 * QiblaAlignedBanner.jsx
 * ----------------------
 * A slim pill banner that fades in when the phone is pointed at the
 * Qibla within tolerance. When misaligned it collapses to zero opacity
 * but keeps its footprint (minHeight: 40) so the layout below does
 * NOT jump — matching the user's PDF spec.
 *
 * Purely presentational.
 */
import React from 'react';

export const QiblaAlignedBanner = ({ aligned, alignedLabel }) => (
  <div
    className="flex items-center justify-center pt-3 pb-1 px-4"
    style={{
      minHeight: 40,
      opacity: aligned ? 1 : 0,
      transition: 'opacity 260ms ease-out',
    }}
    data-testid="qibla-aligned-banner"
  >
    <div
      className="text-heading text-sm md:text-base text-center px-4 py-1.5 rounded-full"
      style={{
        color: '#F1F5F9',
        background: 'linear-gradient(135deg, rgba(34,197,94,0.90), rgba(16,185,129,0.90))',
        border: '1px solid rgba(34,197,94,0.9)',
        boxShadow: '0 4px 18px rgba(34,197,94,0.35)',
      }}
    >
      {alignedLabel}
    </div>
  </div>
);
